import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, getAdminToken, setAdminToken } from "../../lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    async function restoreSession() {
      if (!getAdminToken()) {
        if (active) setLoading(false);
        return;
      }
      try {
        const response = await api.me();
        if (active) setAdmin(response.data.admin);
      } catch {
        setAdminToken("");
      } finally {
        if (active) setLoading(false);
      }
    }
    restoreSession();
    return () => { active = false; };
  }, []);

  const login = useCallback(async ({ email, password }) => {
    const response = await api.login({ email, password });
    setAdminToken(response.token);
    setAdmin(response.data.admin);
    return response.data.admin;
  }, []);

  const logout = useCallback(() => {
    setAdminToken("");
    setAdmin(null);
  }, []);

  const value = useMemo(() => ({ admin, loading, isAuthenticated: Boolean(admin), login, logout }), [admin, loading, login, logout]);
  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
}

export function useAdminAuth() {
  const context = useContext(AdminAuthContext);
  if (!context) throw new Error("useAdminAuth must be used inside AdminAuthProvider.");
  return context;
}
